import type { ConstructionTypeData } from 'gql/graphql';
import { Tabs, Loader } from 'uikit';

import * as R from 'ramda';
import type React from 'react';
import { useCallback, useMemo } from 'react';

interface IWorkOrderConstructionTypesProps {
    onChange: (id: number | undefined) => void;
    constructionTypes?: ConstructionTypeData[] | null;
    activeConstructionTypeId: number;
}

const getLabel = R.prop('name');

const style = { height: 40, width: '100%' };

export const WorkOrderConstructionTypesTabSelect: React.FC<IWorkOrderConstructionTypesProps> = (props) => {
    const { constructionTypes, activeConstructionTypeId, onChange } = props;

    const items = useMemo(() => constructionTypes ?? [], [constructionTypes]);

    const handleTabChange = useCallback(
        ({ value }) => {
            onChange(value.id);
        },
        [onChange],
    );

    const value = useMemo(
        () => items.find((item) => item.id === activeConstructionTypeId) ?? items[0],
        [activeConstructionTypeId, items],
    );

    return items.length ? (
        <Tabs items={items} getItemLabel={getLabel} onChange={handleTabChange} value={value} fitMode="scroll" />
    ) : (
        <div style={style}>
            <Loader />
        </div>
    );
};

WorkOrderConstructionTypesTabSelect.displayName = 'WorkOrderConstructionTypesTabSelect';
